import './depoCard.css';

import { GoogleIcon, FiveStars } from './depoImg';

const DepoCard = (props) => {
  const { iniciais, texto } = props;
  
  return (
    <div className="psico__depoCard">
      <div className='psico__depoCard-header'>
        <div className='psico__depoCard-header_icon'>
          <img src={GoogleIcon} alt="Ícone Google" />
        </div>

        <div className='psico__depoCard-header_nome'>
          <span>{iniciais}</span>
          <img src={FiveStars} alt="Avaliação 5 Estrelas" />
        </div>
      </div>

      <div className='psico__depoCard-content'>
        <span>{texto}</span>
      </div>
    </div>
  )
}

export default DepoCard
